import { render, staticRenderFns } from "./contract_draft_work_ru.vue?vue&type=template&id=eb554482&scoped=true&"
import script from "./contract_draft_work_ru.vue?vue&type=script&lang=js&"
export * from "./contract_draft_work_ru.vue?vue&type=script&lang=js&"
import style0 from "./contract_draft_work_ru.vue?vue&type=style&index=0&id=eb554482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb554482",
  null
  
)

export default component.exports